<template>
  <div>

    <!-- 시설물의 실질적 성격 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 시설물의 실질적 성격</h5>
      <div class="grid gap-3">
        <vs-radio :vs-value="1" vs-name="실질적성격" :disabled="readonly" v-model="form.실질적성격">시설물을 직접 설계·제조·표시·유통(판매) ▶ 제조물책임법상 원료·제조물</vs-radio>
        <vs-radio :vs-value="0" vs-name="실질적성격" :disabled="readonly" v-model="form.실질적성격">시설물을 설치·운영·유지·관리 ▶ 상시 불특정 다수가 이용하는 공중이용시설물</vs-radio>
      </div>
    </div>

    <!-- 기본현황 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기본현황</h5>
      <div class="writeGridContainer">
        <div>
          <div>시설물번호</div>
          <p v-if="isPrint">{{form.facilityNumber}}</p>
          <ml-input v-else v-model="form.facilityNumber" :readonly="readonly"/>
        </div>
        <div>
          <div>관리번호</div>
          <p v-if="isPrint" class="py-2">{{form.managementNumber}}</p>
          <ml-input v-else v-model="form.managementNumber" :readonly="readonly"/>
        </div>
        <div>
          <div>시설물명</div>
          <p v-if="isPrint" class="py-2">{{form.facilityName}}</p>
          <ml-input v-else v-model="form.facilityName" :readonly="readonly"/>
        </div>
        <div>
          <div>하천명 - 구분</div>
          <p v-if="isPrint" class="py-2">{{form.routeDivision}}</p>
          <ml-input v-else v-model="form.routeDivision" :readonly="readonly"/>
        </div>
        <div>
          <div>하천명 - 세부노선</div>
          <p v-if="isPrint" class="py-2">{{form.routeDetail}}</p>
          <ml-input v-else v-model="form.routeDetail" :readonly="readonly"/>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 구분</div>
          <p v-if="isPrint" class="py-2">{{form.cat1}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.cat1" />
          <vs-select v-else autocomplete v-model="form.cat1" @change="onChangeCat1">
            <vs-select-item v-for="(option, idx) in cat1List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 종류</div>
          <p v-if="isPrint" class="py-2">{{form.cat2}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.cat2" />
          <vs-select v-else :disabled="!form.cat1" autocomplete v-model="form.cat2" @change="onChangeCat2">
            <vs-select-item v-for="(option, idx) in cat2List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 세분류</div>
          <p v-if="isPrint" class="py-2">{{form.cat3}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.cat3" />
          <vs-select v-else :disabled="!form.cat2" autocomplete v-model="form.cat3" @change="onChangeCat3">
            <vs-select-item v-for="(option, idx) in cat3List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>종별</div>
          <p v-if="isPrint" class="py-2">{{form.classification}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.classification" />
          <vs-select v-else :disabled="!form.cat3" autocomplete v-model="form.classification" @change="onChangeCat4">
            <vs-select-item v-for="(option, idx) in classificationList" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>SOC성능평가대상</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`SOC성능평가대상_${option}`" v-model="form.socEvaluationTarget"
                      vs-name="SOC성능평가대상" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div class="writeGridCol2">
          <div>주소</div>
          <p v-if="isPrint" class="py-2">{{form.address}}</p>
          <ml-input v-else v-model="form.address" placeholder="(시,도) (시,군,구) (읍,면,동) (리, 번지 등 주소)" :readonly="readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>관리주체</div>
          <p v-if="isPrint" class="py-2">{{form.management_entity}}</p>
          <ml-input v-else v-model="form.management_entity" :readonly="readonly" />
        </div>
        <div>
          <div>관리주체구분</div>
          <div class="radio">
            <vs-radio v-for="option in ['중앙부처', '지자체', '(국가/지방)공기업', '민간']" :key="`관리주체구분_${option}`"
                      v-model="form.management_type" vs-name="관리주체구분" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>소유자</div>
          <p v-if="isPrint" class="py-2">{{form.owner}}</p>
          <ml-input v-else v-model="form.owner" :readonly="readonly" />
        </div>
        <div>
          <div>소유자구분</div>
          <div class="radio">
            <vs-radio v-for="option in ['중앙부처', '지자체', '(국가/지방)공기업', '민간']" :key="`소유자구분_${option}`"
                      v-model="form.ownerType" vs-name="소유자구분" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>사업계획승인일</div>
          <p v-if="isPrint" class="py-2">{{form.businessPlanApprovalDate}}</p>
          <DateSelector v-else v-model="form.businessPlanApprovalDate" :readonly="readonly" />
        </div>
        <div>
          <div>준공(사용승인)일</div>
          <p v-if="isPrint" class="py-2">{{form.completionDate}}</p>
          <DateSelector v-else v-model="form.completionDate" :readonly="readonly" />
        </div>
        <div>
          <div>하자담보책임만료일</div>
          <p v-if="isPrint" class="py-2">{{form.defectLiabilityExpirationDate1}}</p>
          <DateSelector v-else v-model="form.defectLiabilityExpirationDate1" :readonly="readonly" />
        </div>
        <div>
          <div>상세제원</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`상세제원_${option}`" v-model="form.detailedSpecifications"
                      vs-name="상세제원" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>안전점검 및 정밀안전진단 이력</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`안전점검및정밀안전진이력_${option}`"
                      v-model="form.safetyInspectionAndDiagnosisHistory" vs-name="안전점검및정밀안전진이력" :vs-value="option" :disabled="readonly || isPrint">
              {{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>보수·보강 이력</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`보수보강이력_${option}`"
                      v-model="form.repairAndReinforcementHistory" vs-name="보수보강이력" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>환기구 덮개 (접근 가능한 환기구)</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`환기구덮개_${option}`" v-model="form.accessibleVentCover"
                      vs-name="환기구 덮개 (접근 가능한 환기구)" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>설계기간</div>
          <p v-if="isPrint" class="py-2">{{form.designPeriod ? `${form.designPeriod.sDate} ~ ${form.designPeriod.eDate}` : ''}}</p>
          <DateSelectorRang v-else v-model="form.designPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>설계자</div>

          <p v-if="isPrint" class="py-2">{{form.designer}}</p>
          <ml-input v-else v-model="form.designer" :readonly="readonly" />
        </div>
        <div>
          <!--            <div>하자담보책임만료일</div>-->
          <!--            <DateSelector v-model="form.defectLiabilityExpirationDate2" />-->
        </div>
        <div>
          <div>공사기간</div>
          <p v-if="isPrint" class="py-2">{{form.constructionPeriod ? `${form.constructionPeriod.sDate} ~ ${form.constructionPeriod.eDate}` : ''}}</p>
          <DateSelectorRang v-else v-model="form.constructionPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>시공자</div>
          <p v-if="isPrint" class="py-2">{{form.contractor}}</p>
          <ml-input v-else v-model="form.contractor" :readonly="readonly" />
        </div>
        <div>
          <div>총공사비</div>
          <div class="after-text">
            <p v-if="isPrint" class="py-2">{{form.totalConstructionCost}}</p>
            <comma-input v-else v-model="form.totalConstructionCost" :readonly="readonly" />
            <span>백만원</span>
          </div>
        </div>
        <div>
          <div>내진설계 대상 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['대상', '미대상', '불명']" :key="`내진설계대상유무_${option}`"
                      v-model="form.seismicDesignTarget" vs-name="내진설계대상유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>내진설계 적용 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['적용', '미적용', '불명']" :key="`내진설계적용유무_${option}`"
                      v-model="form.seismicDesignApplication" vs-name="내진설계적용유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>적용내진설계기준</div>
          <p v-if="isPrint" class="py-2">{{form.seismicDesignStandard}}</p>
          <ml-input v-else v-model="form.seismicDesignStandard" :readonly="readonly" />
        </div>
        <div>
          <div>내진성능평가 실시 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['실시', '미실시', '불명']" :key="`내진성능평가실시유무_${option}`"
                      v-model="form.seismicPerformanceEvaluation" vs-name="내진성능평가실시유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>내진보강 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['실시', '미실시', '불명']" :key="`내진보강유무_${option}`"
                      v-model="form.seismicReinforcement" vs-name="내진보강유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>영21조대상</div>
          <div class="radio">
            <vs-radio v-for="option in ['예', '아니오']" :key="`영21조대상_${option}`" v-model="form.young21Target"
                      vs-name="영21조대상" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>감리기간</div>
          <p v-if="isPrint" class="py-2">{{form.auditPeriod ? `${form.auditPeriod.sDate} ~ ${form.auditPeriod.eDate}` : ''}}</p>
          <DateSelectorRang v-else v-model="form.auditPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>감리자(책임감리원)</div>
          <p v-if="isPrint" class="py-2">{{form.auditor}}</p>
          <ml-input v-else v-model="form.auditor" :readonly="readonly" />
        </div>
        <div>
          <div>사업주체(발주자)</div>
          <p v-if="isPrint" class="py-2">{{form.projectOwner}}</p>
          <ml-input v-else v-model="form.projectOwner" :readonly="readonly" />
        </div>
        <div>
          <div>공사명</div>
          <p v-if="isPrint" class="py-2">{{form.constructionName}}</p>
          <ml-input v-else v-model="form.constructionName" :readonly="readonly" />
        </div>
        <div>
          <div>공사감독·공사관리관</div>
          <p v-if="isPrint" class="py-2">{{form.constructionSupervisor}}</p>
          <ml-input v-else v-model="form.constructionSupervisor" :readonly="readonly" />
        </div>
        <div>
          <div>작성일</div>
          <p v-if="isPrint" class="py-2">{{form.creationDate}}</p>
          <DateSelector v-else v-model="form.creationDate" :readonly="readonly" />
        </div>
        <div>
          <div>작성자</div>
          <p v-if="isPrint" class="py-2">{{form.author}}</p>
          <ml-input v-else v-model="form.author" :readonly="readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.signature" :readonly="readonly || isPrint" />
        </div>
        <div>
          <div>최종 수정일</div>
          <p v-if="isPrint" class="py-2">{{form.lastModifiedDate}}</p>
          <DateSelector v-else v-model="form.lastModifiedDate" :readonly="readonly" />
        </div>
        <div>
          <div>최종 수정자</div>
          <p v-if="isPrint" class="py-2">{{form.lastModifiedBy}}</p>
          <ml-input v-else v-model="form.lastModifiedBy" :readonly="readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>비고</div>
          <p v-if="isPrint" class="py-2" style="white-space:pre-wrap;">{{form.remarks}}</p>
          <ml-textarea v-else v-model="form.remarks" :readonly="readonly" />
        </div>
      </div>
    </div>

    <!-- 상세제원 -->
    <div class="mt-28px">
      <!-- 상세제원 -->
      <div>
        <h5 class="mb-4"><i class="dot"></i> 상세제원</h5>
        <div class="overflow-x-auto">
          <table style="min-width:800px">
            <tr>
              <th>취수시설</th>
              <th>취수장</th>
              <th>정수장</th>
              <th>가압장</th>
              <th>배수지</th>
              <th>수로터널</th>
              <th>취수댐</th>
              <th>수관교</th>
              <th>관로시설</th>
            </tr>
            <tr>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.취수시설 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.취수시설"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.취수장 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.취수장"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.정수장 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.정수장"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.가압장 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.가압장"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.배수지 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.배수지"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.수로터널 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.수로터널"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.취수댐 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.취수댐"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.수관교 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" :min-value="0" :max-value="12" v-model="form.상세제원.수관교"/>
                  개
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="w-full p-3">{{ form.상세제원.관로시설 }}</p>
                  <ml-input v-else class="w-full mr-2" type="number" v-model="form.상세제원.관로시설"/>
                  km
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="flex justify-end" style="color:#3C3C3C; font-weight: 400; font-size: 14px;">
          ※ 수로터널, 취수댐, 수관교는 FMS 내에서 상위기관이 입력하는 정보로, 개수만 입력
        </div>
      </div>

      <!-- 취수시설 -->
      <div class="mt-4" v-for="(취수시설, index) in form.취수시설" :key="`취수시설_${index}`">
        <h5 class="mb-4">- 취수시설</h5>
        <div class="overflow-x-auto">
          <table style="min-width:800px">
            <tr>
              <th>명칭</th>
              <th>시설용량</th>
              <th>취수원</th>
              <th>취수형식</th>
              <th>하천수계</th>
              <th>하천명</th>
              <th>하천등급</th>
              <th>부대시설</th>
            </tr>
            <tr>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.명칭}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.명칭"/>
              </td>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.시설용량}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.시설용량"/>
              </td>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.취수원}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.취수원"/>
              </td>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.취수형식}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.취수형식"/>
              </td>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.하천수계}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.하천수계"/>
              </td>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.하천명}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.하천명"/>
              </td>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.하천등급}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.하천등급"/>
              </td>
              <td>
                <p v-if="isPrint" class="p-3" style="font-weight: normal">{{취수시설.부대시설}}</p>
                <ml-input v-else class="w-full" v-model="취수시설.부대시설"/>
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2 grid grid-cols-2" style="gap: 16px;">
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>주소</div>
            <div>
              <p v-if="isPrint" class="py-3">{{취수시설.주소}}</p>
              <ml-input v-else class="w-full" v-model="취수시설.주소"/>
            </div>
          </div>
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>관련정수장</div>
            <div>
              <p v-if="isPrint" class="py-3">{{취수시설.관련정수장}}</p>
              <ml-input v-else class="w-full" v-model="취수시설.관련정수장"/>
            </div>
          </div>
        </div>
      </div>

      <!-- 취수장 -->
      <div class="mt-4" v-for="(취수장, index) in form.취수장" :key="`취수장_${index}`">
        <h5 class="mb-4">- 취수장</h5>
        <div class="overflow-x-auto">
          <table style="min-width:800px">
            <tr>
              <th>명칭</th>
              <th>시설용량</th>
              <th>펌프사양</th>
              <th>건축물연면적</th>
              <th>부대시설</th>
            </tr>
            <tr>
              <td>
                <p v-if="isPrint" class="py-3">{{취수장.명칭}}</p>
                <ml-input v-else class="w-full" v-model="취수장.명칭"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{취수장.시설용량}}</p>
                <ml-input v-else class="w-full" v-model="취수장.시설용량"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{취수장.펌프사양}}</p>
                <ml-input v-else class="w-full" v-model="취수장.펌프사양"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{취수장.건축물연면적}}</p>
                <ml-input v-else class="w-full" v-model="취수장.건축물연면적"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{취수장.부대시설}}</p>
                <ml-input v-else class="w-full" v-model="취수장.부대시설"/>
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2 grid grid-cols-2" style="gap: 16px;">
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>주소</div>
            <div>
              <p v-if="isPrint" class="py-3">{{취수장.주소}}</p>
              <ml-input v-else class="w-full" v-model="취수장.주소"/>
            </div>
          </div>
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>관련정수장</div>
            <div>
              <p v-if="isPrint" class="py-3">{{취수장.관련정수장}}</p>
              <ml-input v-else class="w-full" v-model="취수장.관련정수장"/>
            </div>
          </div>
        </div>
      </div>

      <!-- 정수장 -->
      <div class="mt-4" v-for="(정수장, index) in form.정수장" :key="`정수장_${index}`">
        <h5 class="mb-4">- 정수장</h5>
        <div class="overflow-x-auto">
          <table style="min-width:800px;">
            <tr>
              <th rowspan="2">명칭</th>
              <th rowspan="2">시설용량</th>
              <th colspan="2">착수정</th>
              <th colspan="2">혼화지</th>
              <th colspan="2">응접침전지</th>
              <th colspan="2">여과지</th>
              <th colspan="2">정수지</th>
              <th rowspan="2">고도처리시설</th>
              <th rowspan="2">배출수처리시설</th>
              <th rowspan="2">건축물연면적</th>
            </tr>
            <tr>
              <th>형식</th>
              <th>개수(지)</th>
              <th>형식</th>
              <th>개수(지)</th>
              <th>형식</th>
              <th>개수(지)</th>
              <th>형식</th>
              <th>개수(지)</th>
              <th>형식</th>
              <th>개수(지)</th>
            </tr>
            <tr>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.명칭}}</p>
                <ml-input v-else class="w-full" v-model="정수장.명칭"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.시설용량}}</p>
                <ml-input v-else class="w-full" v-model="정수장.시설용량"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.착수정_형식}}</p>
                <ml-input v-else class="w-full" v-model="정수장.착수정_형식"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.착수정_개수}}</p>
                <ml-input v-else class="w-full" v-model="정수장.착수정_개수"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.혼화지_형식}}</p>
                <ml-input v-else class="w-full" v-model="정수장.혼화지_형식"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.혼화지_개수}}</p>
                <ml-input v-else class="w-full" v-model="정수장.혼화지_개수"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.응접침전지_형식}}</p>
                <ml-input v-else class="w-full" v-model="정수장.응접침전지_형식"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.응접침전지_개수}}</p>
                <ml-input v-else class="w-full" v-model="정수장.응접침전지_개수"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.여과지_형식}}</p>
                <ml-input v-else class="w-full" v-model="정수장.여과지_형식"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.여과지_개수}}</p>
                <ml-input v-else class="w-full" v-model="정수장.여과지_개수"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.정수지_형식}}</p>
                <ml-input v-else class="w-full" v-model="정수장.정수지_형식"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.정수지_개수}}</p>
                <ml-input v-else class="w-full" v-model="정수장.정수지_개수"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.고도처리시설}}</p>
                <ml-input v-else class="w-full" v-model="정수장.고도처리시설"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.배출수처리시설}}</p>
                <ml-input v-else class="w-full" v-model="정수장.배출수처리시설"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{정수장.건축물연면적}}</p>
                <ml-input v-else class="w-full" v-model="정수장.건축물연면적"/>
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2 grid grid-cols-2" style="gap: 16px;">
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>주소</div>
            <div>
              <p v-if="isPrint" class="py-3">{{정수장.주소}}</p>
              <ml-input v-else class="w-full" v-model="정수장.주소"/>
            </div>
          </div>
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>관련정수장</div>
            <div>
              <p v-if="isPrint" class="py-3">{{정수장.관련정수장}}</p>
              <ml-input v-else class="w-full" v-model="정수장.관련정수장"/>
            </div>
          </div>
        </div>
      </div>

      <!-- 가압장 -->
      <div class="mt-4" v-for="(가압장, index) in form.가압장" :key="`가압장_${index}`">
        <h5 class="mb-4">- 가압장</h5>
        <div class="overflow-x-auto">
          <table style="min-width: 800px;">
            <tr>
              <th>명칭</th>
              <th>시설용량</th>
              <th>펌프사양</th>
              <th>건축물연면적</th>
              <th>부대시설</th>
            </tr>
            <tr>
              <td>
                <p v-if="isPrint" class="py-3">{{가압장.명칭}}</p>
                <ml-input v-else class="w-full" v-model="가압장.명칭"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{가압장.시설용량}}</p>
                <ml-input v-else class="w-full" v-model="가압장.시설용량"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{가압장.펌프사양}}</p>
                <ml-input v-else class="w-full" v-model="가압장.펌프사양"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{가압장.건축물연면적}}</p>
                <ml-input v-else class="w-full" v-model="가압장.건축물연면적"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{가압장.부대시설}}</p>
                <ml-input v-else class="w-full" v-model="가압장.부대시설"/>
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2 grid grid-cols-2" style="gap: 16px;">
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>주소</div>
            <div>
              <p v-if="isPrint" class="py-3">{{가압장.주소}}</p>
              <ml-input v-else class="w-full" v-model="가압장.주소"/>
            </div>
          </div>
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>관련정수장</div>
            <div>
              <p v-if="isPrint" class="py-3">{{가압장.관련정수장}}</p>
              <ml-input v-else class="w-full" v-model="가압장.관련정수장"/>
            </div>
          </div>
        </div>
      </div>

      <!-- 조절지 및 배수지 -->
      <div class="mt-4" v-for="(배수지, index) in form.배수지" :key="`배수지_${index}`">
        <h5 class="mb-4">- 조절지 및 배수지</h5>
        <div class="overflow-x-auto">
          <table style="min-width: 800px;">
            <tr>
              <th>명칭</th>
              <th>시설용적</th>
              <th>개수(지)</th>
              <th>건축물연면적</th>
              <th>부대시설</th>
            </tr>
            <tr>
              <td>
                <p v-if="isPrint" class="py-3">{{배수지.명칭}}</p>
                <ml-input v-else class="w-full" v-model="배수지.명칭"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{배수지.시설용적}}</p>
                <ml-input v-else class="w-full" v-model="배수지.시설용적"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{배수지.개수}}</p>
                <ml-input v-else class="w-full" v-model="배수지.개수"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{배수지.건축물연면적}}</p>
                <ml-input v-else class="w-full" v-model="배수지.건축물연면적"/>
              </td>
              <td>
                <p v-if="isPrint" class="py-3">{{배수지.부대시설}}</p>
                <ml-input v-else class="w-full" v-model="배수지.부대시설"/>
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2 grid grid-cols-2" style="gap: 16px;">
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>주소</div>
            <div>
              <p v-if="isPrint" class="py-3">{{배수지.주소}}</p>
              <ml-input v-else class="w-full" v-model="배수지.주소"/>
            </div>
          </div>
          <div class="grid items-center" style="grid-template-columns: 114px 1fr; gap: 16px;">
            <div>관련정수장</div>
            <div>
              <p v-if="isPrint" class="py-3">{{배수지.관련정수장}}</p>
              <ml-input v-else class="w-full" v-model="배수지.관련정수장"/>
            </div>
          </div>
        </div>
      </div>

      <!-- 각종 밸브실 -->
      <div class="mt-4">
        <h5 class="mb-4">- 각종 밸브실</h5>
        <div class="overflow-x-auto">
          <table style="min-width: 800px;">
            <tr>
              <th>총 개소</th>
              <th>제수밸브실</th>
              <th>공기밸브실</th>
              <th>이토밸브실</th>
              <th>신축관실</th>
              <th>기타</th>
            </tr>
            <tr>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="print-input">{{form.각종밸브실.총개소}}</p>
                  <ml-input v-else class="w-full" type="number" v-model="form.각종밸브실.총개소" readonly/>
                  <span class="px-2 whitespace-no-wrap">개소</span>
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="print-input">{{form.각종밸브실.제수밸브실}}</p>
                  <ml-input v-else class="w-full" type="number" v-model="form.각종밸브실.제수밸브실"/>
                  <span class="px-2 whitespace-no-wrap">개소</span>
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="print-input">{{form.각종밸브실.공기밸브실}}</p>
                  <ml-input v-else class="w-full" type="number" v-model="form.각종밸브실.공기밸브실"/>
                  <span class="px-2 whitespace-no-wrap">개소</span>
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="print-input">{{form.각종밸브실.이토밸브실}}</p>
                  <ml-input v-else class="w-full" type="number" v-model="form.각종밸브실.이토밸브실"/>
                  <span class="px-2 whitespace-no-wrap">개소</span>
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="print-input">{{form.각종밸브실.신축관실}}</p>
                  <ml-input v-else class="w-full" type="number" v-model="form.각종밸브실.신축관실"/>
                  <span class="px-2 whitespace-no-wrap">개소</span>
                </div>
              </td>
              <td>
                <div class="flex items-center">
                  <p v-if="isPrint" class="print-input">{{form.각종밸브실.기타}}</p>
                  <ml-input v-else class="w-full" type="number" v-model="form.각종밸브실.기타"/>
                  <span class="px-2 whitespace-no-wrap">개소</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 관로시설 -->
      <div class="mt-4">
        <table-custom
          style="padding:0 !important;"
          :board="{ readonly }"
          :is-print="isPrint"
          title="- 관로시설"
          titleType="html"
          :tableData="[
            { id: '계통명칭', title: '계통명칭', type: 'text', placeholder: '내용' },
            { id: '관로구분', title: '관로구분', type: 'text', placeholder: '내용' },
            { id: '관종', title: '관종', type: 'text', placeholder: '내용' },
            { id: '관경', title: '관경', type: 'text', placeholder: '내용' },
            { id: '구간', title: '구간(Station No.)', type: 'text', placeholder: '내용' },
            { id: '연장', title: '연장', type: 'text', placeholder: '내용' },
            { id: '방식설비종류', title: '방식설비종류', type: 'text', placeholder: '내용' },
            { id: '주소', title: '주소', type: 'text', placeholder: '내용' },
            { id: '관련정수장', title: '관련정수장', type: 'text', placeholder: '내용' },
          ]"
          v-model="form.관로시설"
        />

      </div>

    </div>

  </div>
</template>

<script>
import SignField from "@/components/SignField.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  name: "WaterworksWriteBody",
  components: {
    TableCustom,
    SignField,
    DateSelectorRang,
    DateSelector,
  },
  props: {
    form: Object,
    categoryInfo: {
      type: Object,
      default: () => ({cat1: '', cat2: '', cat3: '', classification: ''}),
    },
    initCat1List: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    categoryInfo: {
      immediate: true,
      async handler(value) {
        this.form.facility_category_id = value.id;
        this.form.cat1 = value.cat1;
        await this.onChangeCat1(value.cat1);
        this.form.cat2 = value.cat2;
        await this.onChangeCat2(value.cat2);
        this.form.cat3 = value.cat3;
        await this.onChangeCat3(value.cat3);
        this.form.classification = value.classification;
      },
    },
    'form.상세제원.취수시설'(value) {
      while (Number(`${value}`) > this.form.취수시설.length) {
        this.form.취수시설.push({
          명칭: '',
          시설용량: '',
          취수원: '',
          취수형식: '',
          하천수계: '',
          하천명: '',
          하천등급: '',
          부대시설: '',
          주소: '',
          관련정수장: '',
        })
      }

      while (Number(`${value}`) < this.form.취수시설.length) {
        this.form.취수시설.pop();
      }
    },
    'form.상세제원.취수장'(value) {
      while (Number(`${value}`) > this.form.취수장.length) {
        this.form.취수장.push({
          명칭: '',
          시설용량: '',
          펌프사양: '',
          건축물연면적: '',
          부대시설: '',
          주소: '',
          관련정수장: '',
        })
      }

      while (Number(`${value}`) < this.form.취수장.length) {
        this.form.취수장.pop();
      }
    },
    'form.상세제원.정수장'(value) {
      while (Number(`${value}`) > this.form.정수장.length) {
        this.form.정수장.push({
          명칭: '',
          시설용량: '',
          착수정_형식: '',
          착수정_개수: '',
          혼화지_형식: '',
          혼화지_개수: '',
          응접침전지_형식: '',
          응접침전지_개수: '',
          여과지_형식: '',
          여과지_개수: '',
          정수지_형식: '',
          정수지_개수: '',
          고도처리시설: '',
          배출수처리시설: '',
          건축물연면적: '',
          주소: '',
          관련정수장: '',
        })
      }

      while (Number(`${value}`) < this.form.정수장.length) {
        this.form.정수장.pop();
      }
    },
    'form.상세제원.가압장'(value) {
      while (Number(`${value}`) > this.form.가압장.length) {
        this.form.가압장.push({
          명칭: '',
          시설용량: '',
          펌프사양: '',
          건축물연면적: '',
          부대시설: '',
          주소: '',
          관련정수장: '',
        })
      }

      while (Number(`${value}`) < this.form.가압장.length) {
        this.form.가압장.pop();
      }
    },
    'form.상세제원.배수지'(value) {
      while (Number(`${value}`) > this.form.배수지.length) {
        this.form.배수지.push({
          명칭: '',
          시설용적: '',
          개수: '',
          건축물연면적: '',
          부대시설: '',
          주소: '',
          관련정수장: '',
        })
      }

      while (Number(`${value}`) < this.form.배수지.length) {
        this.form.배수지.pop();
      }
    },
    'form.각종밸브실':{
      handler(value) {
        const 제수밸브실 = Number(`${value.제수밸브실}`)
        const 공기밸브실 = Number(`${value.공기밸브실}`)
        const 이토밸브실 = Number(`${value.이토밸브실}`)
        const 신축관실 = Number(`${value.신축관실}`)
        const 기타 = Number(`${value.기타}`)
        this.form.각종밸브실.총개소 = 제수밸브실 + 공기밸브실 + 이토밸브실 + 신축관실 + 기타;
      },
      deep: true,
    }
  },
  data() {
    return {
      cat1List: [],
      cat2List: [],
      cat3List: [],
      classificationList: [],
    };
  },
  async mounted() {
    // 만약 this.initCat1List 가 비어있다면, this.initCat1List를 초기화한다.
    if (this.initCat1List.length === 0) {
      let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
      if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
        facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      }
      const _cat1List = facilityCategoryListData.data.map((item) => item.cat1);
      const uniqueCat1List = [...new Set(_cat1List)];
      this.cat1List = this.sortItemAndMoveEtcItemToEnd(uniqueCat1List);
    } else {
      this.cat1List = this.initCat1List;
    }

    if (!this.cat1List.includes(this.form.cat1)) {
      this.form.cat1 = "";
      this.form.cat2 = "";
      this.form.cat3 = "";
      this.form.classification = "";
    } else {
      await this.onChangeCat1(this.form.cat1);
    }
  },
  methods: {
    // ==================================================
    // ==================== Category ====================
    // ==================================================
    async onChangeCat1(data) {
      if (data && !this.catLock) {
        this.categoryInfo.cat1 = data;

        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _cat2List = facilityCategoryListData.data.filter((item) => item.cat1 === data).map((item) => item.cat2);
        const uniqueCat2List = [...new Set(_cat2List)];
        this.cat2List = this.sortItemAndMoveEtcItemToEnd(uniqueCat2List);

        // 만약 this.cat2가 this.cat2List 내에 없다면, cat2, cat3, cat4를 초기화한다.
        if (this.cat2List.indexOf(this.form.cat2) === -1) {
          this.form.cat2 = "";
          this.form.cat3 = "";
          this.form.classification = "";
        }
      }
    },
    async onChangeCat2(data) {
      if (data && !this.catLock) {
        this.categoryInfo.cat2 = data;

        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _cat3List = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 && item.cat2 === data).map((item) => item.cat3);
        const uniqueCat3List = [...new Set(_cat3List)];
        this.cat3List = this.sortItemAndMoveEtcItemToEnd(uniqueCat3List);

        // 만약 this.cat3가 this.cat3List 내에 없다면, cat3, cat4를 초기화한다.
        if (this.cat3List.indexOf(this.form.cat3) === -1) {
          this.form.cat3 = "";
          this.form.classification = "";
        }
      }
    },
    async onChangeCat3(data) {
      if (data && !this.catLock) {
        this.categoryInfo.cat3 = data;

        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _classificationList = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 && item.cat2 === this.form.cat2 && item.cat3 === data).map((item) => item.classification);
        const uniqueClassificationList = [...new Set(_classificationList)];
        this.classificationList = this.sortItemAndMoveEtcItemToEnd(uniqueClassificationList);

        // 만약 this.classification이 this.classificationList 내에 없다면, classification을 초기화한다.
        if (this.classificationList.indexOf(this.form.classification) === -1) {
          if (this.classificationList.length === 1) {
            this.form.classification = this.classificationList[0];
          } else {
            this.form.classification = "";
          }
        }
      }
    },
    onChangeCat4(classification) {
      if (!this.catLock) {
        this.form.classification = classification;
        this.categoryInfo.classification = classification;
        this.setFacilityCategoryId();
      }
    },

    /**
     * 현재까지 선택된 cat1, cat2, cat3, classification에 해당하는 facility_category_id를 설정하는 함수입니다.
     *
     * @returns {Promise<void>}
     */
    async setFacilityCategoryId() {
      let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
      if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
        facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      }
      const found = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 &&
        item.cat2 === this.form.cat2 &&
        item.cat3 === this.form.cat3 &&
        item.classification === this.form.classification);

      if (found.length > 0) {
        this.form.facility_category_id = found[0].id;
      }
    },

    /**
     * 배열을 정렬하고, "기타" 문자가 포함된 항목을 배열의 마지막으로 이동하는 함수입니다.
     * 이 함수는 배열을 받아서, 배열의 요소를 정렬한 후, "기타" 문자가 포함된 항목을 찾아 배열의 마지막으로 이동시킵니다.
     *
     * @param {Array} list - 정렬하고, "기타" 문자가 포함된 항목을 마지막으로 이동시킬 배열
     * @returns {Array} 정렬되고, "기타" 문자가 포함된 항목이 마지막으로 이동된 배열
     */
    sortItemAndMoveEtcItemToEnd(list) {
      list.sort();

      // list 아이템 중에 "기타" 문자가 포함된 항목을 찾아서 배열의 마지막으로 이동시킨다.
      const otherIdx = list.findIndex((item) => item.includes("기타"));
      if (otherIdx !== -1) {
        list.push(list.splice(otherIdx, 1)[0]);
      }

      return list;
    },

    // ==================================================
    // ==================================================
  },
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
